export const TOOLTIP_TEXT = {
  MENU: '主選單',
  SEARCH: '搜尋',
  CLEAR_SEARCH: '清除搜尋內容',
  PIN: '固定記事',
  CANCEL_PIN: '取消固定記事',
  REMOVE: '移除',
  GO_URL: '前往連結',
  PREVIEW_URL: '連結預覽選項',
  VIEW_GRID: '格狀檢視',
  VIEW_LIST: '清單檢視',
  DARK_MODE: '啟用深色主題',
  LIGHT_MODE: '啟用淺色主題',
  LOGOUT: '登出',
  DELETE_LABEL: '刪除標籤',
  RENAME_LABEL: '重新命名標籤',
  SAVE_RENAME_LABEL: '儲存修改標籤',
  CANCEL: '取消',

  // toolbar
  PALETTE: '變更顏色',
  LABEL: '新增標籤',
  CANCEL_LABEL: '移除標籤',
  CHECKBOX: '顯示核取方塊',
  CANCEL_CHECKBOX: '隱藏核取方塊',
  IMAGE: '新增圖片',
  COPY: '建立副本',
  ARCHIVE: '封存',
  CANCEL_ARCHIVE: '取消封存',
  DELETE_MEMO: '刪除記事',
  MORE: '更多',

  // colors
  COLOR_DEFAULT: '預設',
  COLOR_RED: '紅色',
  COLOR_ORANGE: '橘色',
  COLOR_YELLOW: '黃色',
  COLOR_GREEN: '綠色',
  COLOR_TEAL: '藍綠色',
  COLOR_BLUE: '藍色',
  COLOR_DARK_BLUE: '深藍色',
  COLOR_PURPLE: '紫色',
  COLOR_PINK: '粉紅色',
  COLOR_BROWN: '棕色',
  COLOR_GRAY: '灰色',
};
